import firebase from "firebase/app";
import { ConsoleLogger, Tracker } from "@dpdgroupuk/react-event-tracker";

export const tracker = new Tracker({
  projectRef: "ROUT",
  analytics:
    process.env.NODE_ENV === "development" ||
    `${process.env.REACT_APP_SENTRY_ENV}`.toLowerCase().includes("dev")
      ? ConsoleLogger
      : firebase.analytics(),
});
